(function () {
  'use strict';

  var SELECTOR = '.navbar.d-block.d-xl-none';

  var ASSET_ROOT = '/cdn/shop/t/245/assets/';

  var MENU_DATA = {
    'Engagement Rings': {
      href: '/collections/engagement-rings/',
      viewAllLabel: 'Shop all engagement rings',
      groups: [
        { title: 'Create your ring', variant: 'actions', links: [
          ['Start with a Design', '/collections/engagement-rings/'],
          ['Start with a Lab Diamond', '/collections/lab-diamonds/']
        ] },
        { title: 'Classic shapes', variant: 'shapes', links: [
          ['Round', '/collections/round-cut-diamond-engagement-rings/?filter.v.option.shape=Round', { image: 'spm-shape-round.png' }],
          ['Oval', '/collections/oval-cut-diamond-engagement-rings/?filter.v.option.shape=Oval', { image: 'spm-shape-oval.png' }],
          ['Cushion', '/collections/cushion-cut-diamond-engagement-rings/?filter.v.option.shape=Cushion', { image: 'spm-shape-cushion.png' }],
          ['Long Cushion', '/collections/cushion-cut-diamond-engagement-rings/?filter.v.option.shape=Long+Cushion', { image: 'spm-shape-cushion.png' }],
          ['Emerald', '/collections/emerald-cut-diamond-engagement-rings/?filter.v.option.shape=Emerald', { image: 'spm-shape-emerald.png' }],
          ['Pear', '/collections/pear-cut-diamond-engagement-rings/?filter.v.option.shape=Pear', { image: 'spm-shape-pear.png' }],
          ['Radiant', '/collections/radiant-cut-diamond-engagement-rings/?filter.v.option.shape=Radiant', { image: 'spm-shape-radiant.png' }],
          ['Princess', '/collections/princess-cut-diamond-engagement-rings/?filter.v.option.shape=Princess', { image: 'spm-shape-princess.png' }],
          ['Asscher', '/collections/engagement-rings/?filter.v.option.shape=Asscher', { image: 'spm-shape-asscher.png' }],
          ['Marquise', '/collections/marquise-cut-diamond-engagement-rings/?filter.v.option.shape=Marquise', { image: 'spm-shape-marquise.png' }]
        ] },
        { title: 'Featured', variant: 'list', links: [
          ['Best sellers', '/collections/best-sellers/'],
          ['Signature collections', '/collections/best-sellers/'],
          ['New arrivals', '/collections/engagement-rings/?sort_by=created-descending']
        ] },
        { title: 'Engagement ring styles', variant: 'split', links: [
          ['Solitaire', '/collections/solitaire-diamond-engagement-rings/?filter.p.tag=Solitaire'],
          ['Halo', '/collections/halo-diamond-engagement-rings/?filter.p.tag=Halo'],
          ['Hidden Halo', '/collections/hidden-halo-diamond-engagement-rings/?filter.p.tag=Hidden_Halo'],
          ['Three Stone', '/collections/three-stone-diamond-engagement-rings/?filter.p.tag=Three_Stone'],
          ['Side Stone', '/collections/side-stone-diamond-engagement-rings/?filter.p.tag=Side_Stone'],
          ['Pavé', '/collections/pave-diamond-engagement-rings/?filter.p.tag=Pave'],
          ['Floral & Vintage', '/collections/vintage-diamond-engagement-rings/?filter.p.tag=Floral']
        ] },
        { title: 'Specialty cuts', variant: 'specialty', links: [
          ['Elongated Hexagon', '/collections/elongated-hexagon-diamond-engagement-rings/?filter.v.option.shape=Elongated+Hexagon', { image: 'erx-shape-elongated-hexagon.svg' }],
          ['Dutch Marquise', '/collections/dutch-marquise-diamond-engagement-rings/?filter.v.option.shape=Dutch+Marquise', { image: 'erx-shape-dutch-marquise.svg' }],
          ['French Marquise', '/collections/french-marquise-lab-grown-diamonds/', { image: 'erx-shape-french-marquise.svg' }],
          ['Moval', '/collections/moval-diamond-engagement-rings/?filter.v.option.shape=Moval', { image: 'erx-shape-moval.svg' }],
          ['Portuguese', '/collections/portuguese-cut-diamond-engagement-rings/?filter.v.option.shape=Portuguese', { image: 'erx-shape-portuguese.svg' }],
          ['Old Mine', '/collections/antique-cut-diamond-engagement-rings/?filter.v.option.shape=Old+Mine', { image: 'erx-shape-old-mine.svg' }]
        ] },
        { title: 'Shop by metal', variant: 'metals', links: [
          ['White gold', '/collections/white-gold-diamond-engagement-rings/', { swatch: 'white' }],
          ['Yellow gold', '/collections/yellow-gold-diamond-engagement-rings/', { swatch: 'yellow' }],
          ['Rose gold', '/collections/rose-gold-diamond-engagement-rings/', { swatch: 'rose' }],
          ['Platinum', '/collections/platinum-diamond-engagement-rings/', { swatch: 'platinum' }]
        ] },
        { title: 'Our promise', variant: 'spaced', links: [
          ['About us', '/pages/about-us'],
          ['Conflict-free lab diamonds', '/pages/diamond-education'],
          ['Lifetime warranty', '/pages/manufacturing-warranty'],
          ['30-day free returns', '/pages/return-policy']
        ] },
        { title: 'Learn & tools', variant: 'spaced', links: [
          ['Free ring sizer', '/pages/ring-sizer'],
          ['Find my ring size', '/pages/ring-size-chart'],
          ['The 4Cs explained', '/pages/the-4cs-explained'],
          ['How to buy an engagement ring', '/pages/engagement-ring-guide'],
          ['Choosing a setting', '/collections/engagement-rings/']
        ] }
      ]
    },
    'Wedding Bands': {
      href: '/collections/womens-wedding-rings/',
      groups: [
        { title: 'Women’s Bands', variant: 'split', weddingSplit: true, links: [
          ['Diamond Bands', '/collections/womens-diamond-wedding-rings/'],
          ['Eternity Rings', '/collections/womens-eternity-rings/'],
          ['Anniversary Rings', '/collections/anniversary-ring/'],
          ['Gemstone Bands', '/collections/gemstone-wedding-bands/'],
          ['Five-Stone Bands', '/collections/5-stone-rings/'],
          ['Seven-Stone Bands', '/collections/7-stone-rings/'],
          ['Floral Bands', '/collections/floral-wedding-bands/'],
          ['Metal Bands', '/collections/womens-metal-wedding-rings/'],
          ['Shop All Wedding Bands', '/collections/womens-wedding-rings/', { emphasis: true }]
        ] },
        { title: 'Women’s Metals', variant: 'metals', links: [
          ['White Gold', '/collections/womens-white-gold-wedding-band/', { swatch: 'white' }],
          ['Yellow Gold', '/collections/womens-yellow-gold-wedding-band/', { swatch: 'yellow' }],
          ['Rose Gold', '/collections/womens-rose-gold-wedding-band/', { swatch: 'rose' }],
          ['Platinum', '/collections/womens-wedding-rings/', { swatch: 'platinum' }]
        ] },
        { title: 'Men’s Bands', variant: 'split', weddingSplit: true, links: [
          ['Metal Bands', '/collections/mens-metal-wedding-bands/'],
          ['Diamond Bands', '/collections/mens-diamond-wedding-bands/'],
          ['Textured Bands', '/collections/mens-textured-wedding-bands/'],
          ['Beveled Edge', '/collections/mens-beveled-edge-wedding-band/'],
          ['Hammered Bands', '/collections/mens-textured-wedding-bands/'],
          ['Gold Bands', '/collections/mens-gold-wedding-band/'],
          ['All Men’s Jewelry', '/collections/mens-jewelry/'],
          ['Shop All Men’s Bands', '/collections/mens-metal-wedding-bands/', { emphasis: true }]
        ] },
        { title: 'Men’s Metals', variant: 'metals', links: [
          ['White Gold', '/collections/mens-metal-wedding-bands/14k-white-gold/', { swatch: 'white' }],
          ['Yellow Gold', '/collections/mens-metal-wedding-bands/14k-yellow-gold/', { swatch: 'yellow' }],
          ['Rose Gold', '/collections/mens-metal-wedding-bands/14k-rose-gold/', { swatch: 'rose' }],
          ['Platinum', '/collections/mens-metal-wedding-bands/', { swatch: 'platinum' }]
        ] },
        { title: 'Fit & Sizing', variant: 'spaced', links: [
          ['Find My Ring Size', '/pages/ring-size-chart'],
          ['Free Ring Sizer', '/pages/ring-sizer']
        ] }
      ]
    },
    'Diamonds': {
      href: '/collections/lab-diamonds/',
      groups: [
        { title: 'Create your ring', variant: 'actions', links: [
          ['Start with a Design', '/collections/engagement-rings/'],
          ['Start with a Lab Diamond', '/collections/lab-diamonds/']
        ] },
        { title: 'Featured', variant: 'spaced', links: [
          ['Dutch Marquise Cut Diamonds', '/collections/dutch-marquise-lab-grown-diamonds/'],
          ['Portuguese Cut Diamonds', '/collections/portuguese-cut-lab-grown-diamonds/'],
          ['Moval Cut Diamonds', '/collections/moval-lab-grown-diamonds/'],
          ['Shop All Lab Diamonds', '/collections/lab-diamonds/', { emphasis: true }]
        ] },
        { title: 'Classic shapes', variant: 'shapes', links: [
          ['Round', '/collections/round-cut-lab-grown-diamonds/', { image: 'spm-shape-round.png' }],
          ['Princess', '/collections/princess-cut-lab-grown-diamonds/', { image: 'spm-shape-princess.png' }],
          ['Oval', '/collections/oval-cut-lab-grown-diamonds/', { image: 'spm-shape-oval.png' }],
          ['Cushion', '/collections/cushion-cut-lab-grown-diamonds/', { image: 'spm-shape-cushion.png' }],
          ['Long Cushion', '/collections/cushion-cut-lab-grown-diamonds/?filter.v.option.shape=Long%20Cushion', { image: 'spm-shape-cushion.png' }],
          ['Emerald', '/collections/emerald-cut-lab-grown-diamonds/', { image: 'spm-shape-emerald.png' }],
          ['Pear', '/collections/pear-cut-lab-grown-diamonds/', { image: 'spm-shape-pear.png' }],
          ['Radiant', '/collections/radiant-cut-lab-grown-diamonds/', { image: 'spm-shape-radiant.png' }],
          ['Marquise', '/collections/marquise-cut-lab-grown-diamonds/', { image: 'spm-shape-marquise.png' }],
          ['Asscher', '/collections/asscher-cut-lab-grown-diamonds/', { image: 'spm-shape-asscher.png' }]
        ] },
        { title: 'Specialty cuts', variant: 'specialty', links: [
          ['French Marquise', '/collections/french-marquise-lab-grown-diamonds/', { image: 'erx-shape-french-marquise.svg' }],
          ['Portuguese', '/collections/portuguese-cut-lab-grown-diamonds/', { image: 'erx-shape-portuguese.svg' }],
          ['Elongated Hexagon', '/collections/elongated-hexagon-lab-grown-diamonds/', { image: 'erx-shape-elongated-hexagon.svg' }],
          ['Dutch Marquise', '/collections/dutch-marquise-lab-grown-diamonds/', { image: 'erx-shape-dutch-marquise.svg' }],
          ['Old Mine', '/collections/antique-cut-lab-grown-diamonds/', { image: 'erx-shape-old-mine.svg' }],
          ['Moval', '/collections/moval-lab-grown-diamonds/', { image: 'erx-shape-moval.svg' }]
        ] },
        { title: 'Carat weight', variant: 'spaced', links: [
          ['1 to 2 ct.', '/collections/1-carat-lab-grown-diamonds/'],
          ['2 to 3 ct.', '/collections/2-carat-lab-grown-diamonds/'],
          ['3 to 4 ct.', '/collections/3-carat-lab-grown-diamonds/'],
          ['4 to 5 ct.', '/collections/4-carat-lab-grown-diamonds/'],
          ['5 ct. & above', '/collections/5-carat-lab-grown-diamonds/']
        ] },
        { title: 'Shop by budget', variant: 'spaced', links: [
          ['$100 to $500', '/collections/lab-diamonds/?filter.v.price.gte=100&filter.v.price.lte=500'],
          ['$500 to $1,500', '/collections/lab-diamonds/?filter.v.price.gte=500&filter.v.price.lte=1500'],
          ['$1,500 to $3,000', '/collections/lab-diamonds/?filter.v.price.gte=1500&filter.v.price.lte=3000'],
          ['$3,000+', '/collections/lab-diamonds/?filter.v.price.gte=3000']
        ] },
        { title: 'Learn', variant: 'spaced', links: [
          ['Diamond Shapes Guide', '/pages/diamond-shapes-guide/'],
          ['The 4Cs Explained', '/pages/the-4cs-explained'],
          ['Diamond Education', '/pages/diamond-education/']
        ] }
      ]
    },
    'Fine Jewelry': {
      href: '/collections/fine-jewelry/',
      footerLink: ['Shop All Jewelry', '/collections/fine-jewelry/'],
      groups: [
        { title: 'Shop by Category', variant: 'actions', links: [
          ['Earrings', '/collections/lab-grown-diamond-earrings/'],
          ['Necklaces', '/collections/necklaces/'],
          ['Rings', '/collections/rings/'],
          ['Bracelets', '/collections/bracelets/']
        ] }
      ]
    },
    'Our Story': {
      href: '/pages/about-us/',
      groups: [
        { title: 'Our house', variant: 'spaced', links: [
          ['Our story', '/pages/about-us/'],
          ['Crafted in NYC', '/pages/about-landing/'],
          ['Meet our gemologists', '/pages/gemologist/'],
          ['Sustainability', '/pages/sustainable-jewelry/'],
          ['Ethical diamonds', '/pages/ethical-diamonds/'],
          ['Our blog', '/blogs/news/']
        ] },
        { title: 'Shop with confidence', variant: 'spaced', links: [
          ['Lifetime warranty', '/pages/manufacturing-warranty/'],
          ['30-day returns', '/pages/return-policy/'],
          ['Free insured shipping', '/pages/free-shipping/'],
          ['International shipping', '/pages/international-shipping/'],
          ['Easy financing', '/pages/easy-financing/'],
          ['Diamond education', '/pages/diamond-education/']
        ] },
        { title: 'Connect', variant: 'spaced', links: [
          ['Customer reviews', '/pages/customer-reviews/'],
          ['Book an appointment', '/pages/book-an-appointment'],
          ['Visit the NYC showroom', '/pages/book-an-appointment'],
          ['Contact us', '/pages/contact-us/'],
          ['FAQs', '/pages/faqs/']
        ] }
      ]
    },
    'Education': {
      href: '/pages/diamond-education/',
      footerLink: ['Explore All Guides', '/pages/diamond-education/'],
      groups: [
        { title: 'Diamond guide', variant: 'spaced', links: [
          ['Diamond Education', '/pages/diamond-education/'],
          ['Diamond Shapes Guide', '/pages/diamond-shapes-guide/'],
          ['Diamond Cut', '/pages/diamond-cut/'],
          ['Diamond Color', '/pages/diamond-color/'],
          ['Diamond Clarity', '/pages/diamond-clarity/'],
          ['Carat Weight', '/pages/carat-weight/']
        ] },
        { title: 'Ring & jewelry guides', variant: 'spaced', links: [
          ['Engagement Ring Guide', '/pages/engagement-ring-guide/'],
          ['Wedding Bands Guide', '/pages/wedding-bands-guide/'],
          ['Custom Jewelry', '/pages/custom-jewelry/'],
          ['Diamond & Jewelry Guide', '/pages/diamond-jewelry-guide/']
        ] },
        { title: 'Materials & trends', variant: 'spaced', links: [
          ['Jewelry Materials', '/pages/jewelry-materials/'],
          ['Jewelry Care', '/pages/jewelry-care/'],
          ['Jewelry Trends', '/pages/jewelry-trends/'],
          ['Trends & Gift Guide', '/pages/trends-gift-guide/']
        ] },
        { title: 'Guides & insights', variant: 'spaced', links: [
          ['Buying Guides', '/pages/buying-guides/'],
          ['Gemology Insights', '/pages/gemology-insights/'],
          ['Sustainability in Jewelry', '/pages/sustainable-jewelry/'],
          ['FAQs', '/pages/faqs/']
        ] }
      ]
    }
  };

  function makeSearchButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sp-mobile-v2-search-toggle';
    button.setAttribute('aria-label', 'Open search');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'sp-mobile-v2-search');
    button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="10.75" cy="10.75" r="6.75"></circle><path d="m15.8 15.8 4.2 4.2"></path></svg>';
    return button;
  }

  function makeBag() {
    var source = document.querySelector('.sp-header-bag-icon--mobile');
    var bag = source ? source.cloneNode(true) : document.createElement('a');
    if (!source) {
      bag.href = '/cart';
      bag.setAttribute('aria-label', 'Bag, 0 items');
      bag.innerHTML = '<span class="sp-header-bag__glyph" aria-hidden="true"></span><span class="sp-header-bag__count" data-cart-count data-sp-header-cart-count hidden aria-hidden="true">0</span>';
    }
    bag.classList.add('sp-header-bag-icon--drawer-v2');
    return bag;
  }

  function lockPanelRoot(drawer) {
    var root = drawer.querySelector('.sp-mobile-v2-root-scroll');
    if (!root) return;

    if (drawer.spMobileV2UnlockTimer) {
      window.clearTimeout(drawer.spMobileV2UnlockTimer);
      drawer.spMobileV2UnlockTimer = null;
    }

    drawer.classList.add('sp-mobile-v2-panel-open');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');
  }

  function unlockPanelRoot(drawer, delay) {
    var root = drawer.querySelector('.sp-mobile-v2-root-scroll');
    if (!root) return;

    if (drawer.spMobileV2UnlockTimer) window.clearTimeout(drawer.spMobileV2UnlockTimer);

    var unlock = function () {
      if (drawer.querySelector('.rs-slidein.is-open')) return;
      drawer.classList.remove('sp-mobile-v2-panel-open');
      root.removeAttribute('aria-hidden');
      root.removeAttribute('inert');
      drawer.spMobileV2UnlockTimer = null;
    };

    if (delay) drawer.spMobileV2UnlockTimer = window.setTimeout(unlock, delay);
    else unlock();
  }

  function closeAllPanels(drawer, revealDelay) {
    drawer.querySelectorAll('.rs-slidein.is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      var trigger = drawer.querySelector('[data-slidein-target="' + panel.id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    unlockPanelRoot(drawer, revealDelay || 0);
  }

  function openPanel(drawer, trigger) {
    var id = trigger.getAttribute('data-slidein-target');
    var panel = id && drawer.querySelector('#' + id);
    if (!panel) return;

    closeSearch(drawer, false);
    drawer.querySelectorAll('.rs-slidein.is-open').forEach(function (otherPanel) {
      if (otherPanel === panel) return;
      otherPanel.classList.remove('is-open');
      otherPanel.setAttribute('aria-hidden', 'true');
    });
    lockPanelRoot(drawer);
    panel.scrollTop = 0;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeSearch(drawer, focusToggle) {
    var search = drawer.querySelector('.sidebarsrch');
    var toggle = drawer.querySelector('.sp-mobile-v2-search-toggle');
    if (!search || !toggle) return;
    search.hidden = true;
    search.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open search');
    if (focusToggle) toggle.focus();
  }

  function openSearch(drawer) {
    var search = drawer.querySelector('.sidebarsrch');
    var toggle = drawer.querySelector('.sp-mobile-v2-search-toggle');
    if (!search || !toggle) return;
    closeAllPanels(drawer, 0);
    search.hidden = false;
    search.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close search');
    requestAnimationFrame(function () {
      var input = search.querySelector('[data-search-input-mobile]');
      if (input) input.focus();
    });
  }

  function buildGeneratedSlidein(drawer, item, label, id) {
    var collapse = item.querySelector('.accordion-collapse');
    var body = collapse && collapse.querySelector('.accordion-body');
    var trigger = item.querySelector('.accordion-button');
    if (!body || !trigger || drawer.querySelector('#' + id)) return;

    var panel = document.createElement('div');
    panel.className = 'rs-slidein sp-mobile-v2-generated';
    panel.id = id;
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', label + ' menu');
    panel.innerHTML = '<div class="rs-slidein__header"><button type="button" class="rs-slidein__back" data-slidein-close aria-label="Back to main menu"><span class="rs-slidein__back-arrow" aria-hidden="true">‹</span><span class="rs-slidein__back-label">' + label + '</span></button></div><div class="rs-slidein__body"></div>';
    panel.querySelector('.rs-slidein__body').appendChild(body.cloneNode(true));
    drawer.appendChild(panel);

    trigger.classList.add('rs-slidein-trigger');
    trigger.setAttribute('data-slidein-target', id);
    trigger.setAttribute('aria-controls', id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.removeAttribute('data-bs-toggle');
    trigger.removeAttribute('data-bs-target');
  }

  function makeDesignedLink(link) {
    var meta = link[2] || {};
    var anchor = document.createElement('a');
    anchor.href = link[1];
    if (meta.emphasis) anchor.className = 'sp-mobile-v2-menu-link-emphasis';

    if (meta.image) {
      var image = document.createElement('img');
      image.src = ASSET_ROOT + meta.image;
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
      image.loading = 'lazy';
      anchor.appendChild(image);
    }

    if (meta.swatch) {
      var swatch = document.createElement('span');
      swatch.className = 'sp-mobile-v2-metal-swatch sp-mobile-v2-metal-swatch-' + meta.swatch;
      swatch.setAttribute('aria-hidden', 'true');
      anchor.appendChild(swatch);
    }

    var copy = document.createElement('span');
    copy.textContent = link[0];
    anchor.appendChild(copy);
    return anchor;
  }

  function renderDesignedSlidein(drawer, item, label, id, menu) {
    var trigger = item && item.querySelector('.accordion-button');
    if (!trigger || !menu) return;

    var panel = drawer.querySelector('#' + id);
    if (!panel) {
      panel = document.createElement('div');
      drawer.appendChild(panel);
    }

    panel.className = 'rs-slidein sp-mobile-v2-designed';
    panel.id = id;
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', label + ' menu');
    panel.setAttribute('data-sp-mobile-v2-content', 'localhost-v1');
    panel.innerHTML = '<div class="rs-slidein__header"><button type="button" class="rs-slidein__back" data-slidein-close aria-label="Back to main menu"><span class="rs-slidein__back-arrow" aria-hidden="true">‹</span><span class="rs-slidein__back-label">Back</span></button><a class="sp-mobile-v2-panel-title"></a></div><div class="rs-slidein__body"><div class="sp-mobile-v2-menu-scroll"><div class="sp-mobile-v2-menu-groups"></div></div></div>';

    var title = panel.querySelector('.sp-mobile-v2-panel-title');
    title.href = menu.href;
    title.textContent = label;

    var groups = panel.querySelector('.sp-mobile-v2-menu-groups');
    groups.classList.add('sp-mobile-v2-menu-groups-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
    menu.groups.forEach(function (group) {
      var section = document.createElement('section');
      var hasEmphasis = group.links.some(function (link) { return link[2] && link[2].emphasis; });
      section.className = 'sp-mobile-v2-menu-group sp-mobile-v2-menu-group-' + (group.variant || 'list');
      if (hasEmphasis) section.classList.add('sp-mobile-v2-menu-group-has-emphasis');
      if (group.weddingSplit) section.classList.add('sp-mobile-v2-menu-group-wedding-split');
      if (label === 'Engagement Rings' && group.title === 'Classic shapes') section.classList.add('sp-mobile-v2-menu-group-has-inline-all');
      if (label === 'Engagement Rings' && group.title === 'Create your ring') section.classList.add('sp-mobile-v2-menu-group-before-shapes');

      var heading = document.createElement('h2');
      heading.textContent = group.title;
      section.appendChild(heading);

      var links = document.createElement('div');
      group.links.forEach(function (link) { links.appendChild(makeDesignedLink(link)); });

      if (label === 'Engagement Rings' && group.title === 'Classic shapes') {
        var all = document.createElement('a');
        all.className = 'sp-mobile-v2-menu-inline-all';
        all.href = menu.href;
        all.innerHTML = '<span></span><svg aria-hidden="true" viewBox="0 0 16 16"><path d="m6 3.5 4.5 4.5L6 12.5"></path></svg>';
        all.querySelector('span').textContent = menu.viewAllLabel;
        links.appendChild(all);
      }

      section.appendChild(links);
      groups.appendChild(section);
    });

    if (menu.footerLink) {
      var footer = document.createElement('a');
      footer.className = 'sp-mobile-v2-menu-footer-link sp-mobile-v2-menu-footer-link-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      footer.href = menu.footerLink[1];
      footer.textContent = menu.footerLink[0];
      panel.querySelector('.sp-mobile-v2-menu-scroll').appendChild(footer);
    }

    trigger.classList.add('rs-slidein-trigger');
    trigger.setAttribute('data-slidein-target', id);
    trigger.setAttribute('aria-controls', id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.removeAttribute('data-bs-toggle');
    trigger.removeAttribute('data-bs-target');
  }

  function decorateSlideins(drawer) {
    var destinations = {
      'Engagement Rings': '/collections/engagement-rings/',
      'Wedding Bands': '/collections/womens-wedding-rings/',
      'Diamonds': '/collections/lab-diamonds/',
      'Fine Jewelry': '/collections/fine-jewelry/',
      'Our Story': '/pages/about-us/',
      'Education': '/pages/diamond-education/'
    };
    drawer.querySelectorAll('.rs-slidein').forEach(function (panel) {
      var header = panel.querySelector('.rs-slidein__header');
      var backLabel = panel.querySelector('.rs-slidein__back-label');
      if (!header || !backLabel || header.querySelector('.sp-mobile-v2-panel-title')) return;
      var label = (panel.getAttribute('aria-label') || backLabel.textContent || '').replace(/\s+menu$/i, '').trim();
      backLabel.textContent = 'Back';
      var title = document.createElement('a');
      title.className = 'sp-mobile-v2-panel-title';
      title.href = destinations[label] || panel.querySelector('.rs-slidein__body a')?.getAttribute('href') || '#';
      title.textContent = label;
      header.appendChild(title);
    });
  }

  function transformContent(drawer) {
    var accordion = drawer.querySelector('.rs-mobile-nav-acc');
    var utilityRow = drawer.querySelector(':scope > .row.m-0.px-4');
    if (!accordion || accordion.dataset.spMobileV2Ready === 'true') return;
    accordion.dataset.spMobileV2Ready = 'true';

    var items = Array.prototype.slice.call(accordion.querySelectorAll(':scope > .accordion-item'));
    var byLabel = {};
    items.forEach(function (item) {
      var button = item.querySelector('.accordion-button');
      if (!button) return;
      var label = button.textContent.trim().replace(/\s+/g, ' ');
      byLabel[label] = item;
    });

    var panels = [
      { source: 'Engagement Rings', label: 'Engagement Rings', id: 'er-slidein' },
      { source: 'Wedding Bands', label: 'Wedding Bands', id: 'wedding-bands-slidein' },
      { source: 'Diamonds', label: 'Diamonds', id: 'diamonds-slidein' },
      { source: 'Fine Jewelry', label: 'Fine Jewelry', id: 'fine-jewelry-slidein' },
      { source: 'About Us', label: 'Our Story', id: 'our-story-slidein' },
      { source: 'Education', label: 'Education', id: 'education-slidein' }
    ];

    panels.forEach(function (config) {
      var item = byLabel[config.source];
      if (!item) return;
      accordion.appendChild(item);
      var button = item.querySelector('.accordion-button');
      var nav = item.querySelector('.accordion-header');
      if (button) button.textContent = config.label;
      if (nav) nav.setAttribute('aria-label', config.label);
      renderDesignedSlidein(drawer, item, config.label, config.id, MENU_DATA[config.label]);
    });

    var root = document.createElement('div');
    root.className = 'sp-mobile-v2-root-scroll';
    drawer.insertBefore(root, accordion);
    root.appendChild(accordion);
    if (utilityRow) root.appendChild(utilityRow);

    unlockPanelRoot(drawer, 0);

    accordion.addEventListener('click', function (event) {
      if (event.target.closest('.accordion-button')) closeSearch(drawer, false);
    }, true);
  }

  function transformShell(drawer) {
    if (drawer.dataset.spMobileV2Shell === 'true') return;
    drawer.dataset.spMobileV2Shell = 'true';
    drawer.classList.add('sp-mobile-v2');

    var promo = drawer.querySelector(':scope > .bg-two');
    var appointment = drawer.querySelector(':scope > .NavBookAppointment');
    if (promo) promo.classList.add('sp-mobile-v2-hidden');
    if (appointment) appointment.classList.add('sp-mobile-v2-hidden');

    var header = drawer.querySelector(':scope > .NavHeader');
    var search = drawer.querySelector(':scope > .sidebarsrch');
    if (!header || !search) return;
    search.id = 'sp-mobile-v2-search';
    search.hidden = true;

    var actions = document.createElement('div');
    actions.className = 'sp-mobile-v2-actions';
    var toggle = makeSearchButton();
    actions.appendChild(toggle);
    actions.appendChild(makeBag());
    header.appendChild(actions);

    toggle.addEventListener('click', function () {
      if (search.hidden) openSearch(drawer);
      else closeSearch(drawer, false);
    });

    var input = search.querySelector('[data-search-input-mobile]');
    var clear = search.querySelector('[data-close-search-mobile]');
    if (clear) clear.addEventListener('click', function () {
      requestAnimationFrame(function () {
        if (input) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }
      });
    });

    var backdrop = document.querySelector('.blackBG');
    var closeControl = header.querySelector('.close_button');
    if (closeControl) closeControl.addEventListener('click', function () {
      closeSearch(drawer, false);
      drawer.classList.remove('navbarActive');
      if (backdrop) backdrop.classList.remove('blackBGActive');
      closeAllPanels(drawer, 0);
    });
    if (backdrop) backdrop.addEventListener('click', function () { closeSearch(drawer, false); });
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-slidein-target]');
      if (trigger && drawer.contains(trigger)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openPanel(drawer, trigger);
        return;
      }

      var back = event.target.closest && event.target.closest('[data-slidein-close]');
      if (back && drawer.contains(back)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var panel = back.closest('.rs-slidein');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
          var opener = drawer.querySelector('[data-slidein-target="' + panel.id + '"]');
          if (opener) opener.setAttribute('aria-expanded', 'false');
        }
        unlockPanelRoot(drawer, 240);
      }
    }, true);

    var observer = new MutationObserver(function () { transformContent(drawer); });
    observer.observe(drawer, { childList: true });

    transformContent(drawer);
  }

  function init() {
    var drawer = document.querySelector(SELECTOR);
    if (drawer) transformShell(drawer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

